<template>
  <div>
    <div v-if="!$store.state.canWrite">
      {{ item[minPaxKey] }}
    </div>
    <div
      v-else
      class="d-flex align-center"
    >
      <v-text-field
        v-model="item[minPaxKey]"
        style="width: 60px"
        class="pa-1"
        dense
        filled
        hide-details
        single-line
        type="number"
        @focus="onFocus()"
        @blur="onBlur()"
        @input="updateNewMinDepartGuarantee()"
      />
      <v-icon
        v-if="showSaveButton && !loading"
        dense
        class="mr-2"
        @click="changeMinDepartGuarantee()"
      >
        mdi-content-save
      </v-icon>
      <v-progress-circular
        v-else-if="loading && sameFieldsBehaviour()"
        color="primary"
        size="25"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>
<script>
const { VUE_APP_GATEWAY_HOST } = process.env;

import { makeFetchRequest } from '../../utils';
import { EventBus } from '../../mixins';
import { globalMixin } from '../../mixins';

import dayjs from 'dayjs';
// import advancedFormat from 'dayjs/plugin/advancedFormat';
// dayjs.extend(advancedFormat);

export default {
  mixins: [globalMixin], // Include the globalMixin in the mixins array
  props: {
    item: {
      type: Object,
      default: null
    },
    tempMinPaxGuarantee: {
      type: Object,
      default: null
    },
    minPaxKey: {
      type: String,
      default: 'min_pax_number_for_warranted_departure',
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSaveButton: false,
      oldMinPaxNumberForWarrantedDeparture: this.item[this.minPaxKey]      
    }
  },
  methods: {
    sameFieldsBehaviour() {
      if (!this.$store.state.canWrite) {
        return false;
      }
      // const date = fromUnixTime(item.date / 1000);
      const dateString = dayjs.utc(this.getItemDate(this.item)).format('DD-MM-YYYY');

      return (
        this.tempMinPaxGuarantee[this.getItemCode(this.item)] &&
        this.tempMinPaxGuarantee[this.getItemCode(this.item)][dateString] &&
        this.tempMinPaxGuarantee[this.getItemCode(this.item)][dateString] !== ''
      );
    },
    async changeMinDepartGuarantee() {
      const min_pax_number_for_warranted_departure = parseInt(
        this.item[this.minPaxKey]
      );

      // Don't save if the value is not a number
      if (isNaN(min_pax_number_for_warranted_departure)) {
        const notification = {
          type: 'danger',
          message: 'Insérer une valeur valide'
        };
        EventBus.$emit('show-notifications', [notification]);
        return;
      }

      // change date from Unix timestamp in miliseconds to seconds
      // convert date in string
      // const date = fromUnixTime(item.date / 1000);
      const dateString = dayjs.utc(this.getItemDate(this.item)).format('DD-MM-YYYY');

      this.$emit('toggle-loading');

      const notification = {
        type: 'success'
      };
      console.log(this.item);
      const body = {
        query: `mutation iresaSetDepartGuarantee($packageCode: Int!, $date: String!, $minPaxWarrantedDeparture: Int!, $idPartner: Int!, $marque: Int!) { 
          iresaSetDepartGuarantee(packageCode: $packageCode, date: $date , minPaxWarrantedDeparture: $minPaxWarrantedDeparture, idPartner: $idPartner, marque: $marque) { 
            success message data 
          }
        }`,
        variables: {
          packageCode: parseInt(this.getItemCode(this.item)),
          date: dateString,
          minPaxWarrantedDeparture: min_pax_number_for_warranted_departure,
          idPartner: this.item.id_partner || this.item.partner,
          marque: this.item.marque
        }
      };

      // Mutation to save min depart guarantee
      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body)
        .then(() => {
          notification.message = 'Garantie de départ minimum enregistrée';
          this.oldMinPaxNumberForWarrantedDeparture = min_pax_number_for_warranted_departure;
          this.showSaveButton = false;
          delete this.tempMinPaxGuarantee[this.getItemCode(this.item)][dateString];
        })
        .catch((err) => {
          console.log('ERR: ', err);
          notification.type = 'danger';
          notification.message = "Une erreur s'est produite";
        });

      // if (response.data?.data?.iresaSetDepartGuarantee?.success) {

      //   delete this.tempMinPaxGuarantee[item.id_package][dateString];

      //   const indexBody = {
      //     query: `mutation callIndexESItems($offersCode: Int!, $date: String!,
      //   $uuid: String) { callIndexESItems(offersCode: $offersCode, date: $date , uuid: $uuid)}`,
      //     variables: {
      //       "offersCode": item.id_package,
      //       "date": dateString.replace(/-/g, "/"),
      //       "uuid": item.uuid ? item.uuid : null
      //     }
      //   }

      //   await makeFetchRequest(VUE_APP_API_SPEEDBOAT_URL, 'POST', indexBody).then(indexResponse => {
      //     if(!indexResponse.success){
      //     // When the vallue is saved but not indexed on ES or/and Algolia
      //     notification.type = "warning";
      //     notification.message = "La garantie de départ min a été enregistrée mais pas indexée";
      //   }else{
      //     notification.message = "Garantie de départ minimum enregistrée";
      //   }

      //   }).catch(error => {
      //     console.log(error);

      //     notification.type = "danger";
      //     notification.message = "Une erreur s'est produite";
      //   });

      // } else {
      //   console.log("ERROR -> ", response)

      //   notification.type = "danger";
      //   notification.message = "Une erreur s'est produite";
      // }

      this.$emit('toggle-loading');

      EventBus.$emit('show-notifications', [notification]);
    },
    setShowSaveButton() {
      this.showSaveButton = (this.oldMinPaxNumberForWarrantedDeparture != this.item[this.minPaxKey]) && this.item[this.minPaxKey] >= 0;
    },
    updateNewMinDepartGuarantee() {     
      this.setShowSaveButton(); 
      this.$emit('update-new-min-depart-guarantee');
    },
    onFocus() {
      this.setShowSaveButton();
    },
    onBlur() { 
      // When the input field loses focus
      this.setShowSaveButton();
    },
  }
};
</script>